import { NgOptimizedImage, NgStyle } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';

@Component({
    selector: 'cs-image',
    templateUrl: 'image.component.html',
    imports: [NgStyle, NgOptimizedImage],
})
export class Image {
    src = input.required<string>();
    isError = input<boolean>();
    alt = input.required<string>();
    priority = input<boolean>(false);
    imageStyle = input<string>('');

    readonly loaded = output<Event>();
    readonly loadedFailed = output<Event>();

    isLoaded = signal<boolean>(false);
    // Adding inherit to width and height since it is overriding the custom css added in features
    styles = computed<string>(
        () => (this.isLoaded() ? ' position: revert-layer; width: revert-layer; height: revert-layer;' : '') + this.imageStyle(),
    ); // Some images were not loading due to position: absolute

    onImageLoad(event: Event) {
        this.loaded.emit(event);
        this.isLoaded.set(true);
    }

    onImageLoadError(event: Event) {
        this.loadedFailed.emit(event);
        this.isLoaded.set(true);
    }
}
